import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

export function useUnidProductsValidationEffect({
    validUnidProducts,
    reportPaymentGridData,
    showReportPayment,
    myCaseRefId,
    countryCode,
    setFilteredProduct,
    setIsReplishBtnClicked,
    setShowUNiDPopUp,
    dispatch,
    getRPValidatedItemTableData,
    getRPValidateItemsArr,
    validateProductDetails,
}) {
    useEffectWithErrorLogging(() => {
        if (
            validUnidProducts &&
            validUnidProducts.length > 0 &&
            reportPaymentGridData.length > 0 &&
            showReportPayment
        ) {
            const validatedItemTableData = getRPValidatedItemTableData(
                reportPaymentGridData,
                validUnidProducts,
                countryCode
            );
            setFilteredProduct(validatedItemTableData);
            validatedItemTableData?.some(
                (item) =>
                    item.isUNiDPlanFeeItem === true ||
                    item.bundleItem?.some(
                        (item) => item.isUNiDPlanFeeItem === true
                    )
            )
                ? (setIsReplishBtnClicked(false), setShowUNiDPopUp(false))
                : (setIsReplishBtnClicked(true), setShowUNiDPopUp(true));
            if (
                validatedItemTableData.some(
                    (item) =>
                        item.isUNiDPlanFeeItem === true ||
                        item.bundleItem?.some(
                            (item) => item.isUNiDPlanFeeItem === true
                        )
                )
                    ? showReportPayment &&
                      reportPaymentGridData.length > 0 &&
                      myCaseRefId
                    : null
            ) {
                const validateItemsArr = getRPValidateItemsArr(
                    reportPaymentGridData
                );
                const validateItemsObj = {
                    myCaseRef: myCaseRefId,
                    products: validateItemsArr,
                };
                dispatch(validateProductDetails(validateItemsObj, true));
            }
        }
    }, [validUnidProducts]);
}